<template>
  <div class="flex flex-col md:flex-row justify-between gap-4 mb-6">
    <div class="flex flex-wrap gap-2">
      <Button 
        v-for="tab in tabs" 
        :key="tab.key"
        :label="tab.label"
        :class="[
          'px-6 py-2 font-semibold rounded-full transition primary-text',
          currentTab === tab.key ? 'bg-white shadow' : 'bg-transparent hover:bg-white/20'
        ]"
        @click="$emit('select-tab', tab.key)"
        text
      />
    </div>
    
    <!-- Action Buttons -->
    <div class="flex gap-2">
      <Button 
        :label="$t('user_manage.invite_member')"
        icon="pi pi-user-plus"
        class="spect-btn-primary rounded-full"
        @click="$emit('open-invite-modal')"
        v-if="currentTab == 'users'"
      />
      <Button 
        :label="$t('user_manage.add_member')"
        icon="pi pi-user-plus"
        class="spect-btn-primary rounded-full"
        @click="$emit('open-add-modal')"
        v-if="currentTab == 'users'"
      />
      <Button 
        :label="$t('user_manage.new_service')"
        icon="pi pi-plus"
        class="spect-btn-primary rounded-full"
        @click="$emit('open-new-service-modal')"
        v-if="currentTab === 'services'"
      />
      <Button 
        :label="$t('user_manage.new_group')"
        icon="pi pi-plus"
        class="spect-btn-primary rounded-full"
        @click="$emit('open-new-group-modal')"
        v-if="currentTab === 'groups'"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue"
import Button from 'primevue/button'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
console.log(t)


defineProps({
  currentTab: {
    type: String,
    required: true
  },
  tabs: {
    type: Array,
    required: true
  }
})

defineEmits([
  'select-tab',
  'open-invite-modal',
  'open-add-modal',
  'open-new-service-modal',
  'open-new-group-modal'
])
</script>

<style lang="scss" scoped>
@use "../../assets/scss/variables.scss";
@use "../../assets/scss/app/common.scss";
</style>